import * as React from 'react';
import { DataTable } from '@frontend/app/refresh-components/DataTableV2';
import { StatCard } from './StatCard';

const dummyColumns = [
    { id: 'offerName', header: 'Name', accessorKey: 'offerName' },
    { id: 'programId', header: 'Connected Project', accessorKey: 'programId' },
    { id: 'url', header: 'URL', accessorKey: 'url' },
    { id: 'status', header: 'Status', accessorKey: 'status' },
    { id: 'members', header: 'Members', accessorKey: 'members' },
    { id: 'clicks', header: 'Clicks', accessorKey: 'clicks' },
    { id: 'conversions', header: 'Conversions', accessorKey: 'conversions' },
    { id: 'salesAmount', header: 'Sales Amt', accessorKey: 'salesAmount' },
    { id: 'payoutEarned', header: 'Commissions Earned', accessorKey: 'payoutEarned' },
    { id: 'payoutMade', header: 'Payout', accessorKey: 'payoutMade' },
    { id: 'avgSale', header: 'Avg. Sale', accessorKey: 'avgSale' },
    { id: 'createdDate', header: 'Created On', accessorKey: 'createdDate' },
];

export const LoadingState: React.FC = () => {
    return (
      <>
        <div className="grid grid-cols-1 gap-4 xs:grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 p-4">
          <StatCard
            title="Members"
            bgColor="bg-purple-5"
            widgetIcon={<div className="w-5 h-5 bg-white rounded" />}
            value={0}
            metricType="count"
            subHeading="0 with Conversions"
            tooltip="The number of members added across this offer. The metric below shows how many of them have driven at least one conversion."
            isLoading
          />
          <StatCard
            title="Conversions"
            bgColor="bg-blue-5"
            widgetIcon={<div className="w-5 h-5 bg-white rounded" />}
            value={0}
            metricType="number"
            tooltip="Shows the number of conversions driven by members across this offer. The metric below shows the number of clicks."
            isLoading
          />
          <StatCard
            title="Total Sales"
            bgColor="bg-teal-5"
            widgetIcon={<div className="w-5 h-5 bg-white rounded" />}
            value={0}
            metricType="currency"
            tooltip="Shows the total sales driven by members across this offer. The metric below shows the average sales per member."
            isLoading
          />
          <StatCard
            title="Commissions Earned"
            bgColor="bg-lime-5"
            widgetIcon={<div className="w-5 h-5 bg-white rounded" />}
            value={0}
            metricType="currency"
            tooltip="Shows the total commissions earned by members across this offer. The metric below shows the average commission earned per member."
            isLoading
          />
          <StatCard
            title="Payments Due"
            bgColor="bg-yellow-5"
            widgetIcon={<div className="w-5 h-5 bg-white rounded" />}
            value={0}
            metricType="currency"
            tooltip="Shows the total unpaid commissions and cash rewards for members across this offer, with a breakdown on hover. The metric below shows the number of members with pending payments from conversions."
            isLoading
          />
        </div>
        <DataTable
          columns={dummyColumns}
          data={Array(8).fill({})}
          isLoading
        />
      </>
    );
};
